import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  duration: string; // e.g. "1 day ago", "1 month ago", "1 year ago"
}

export const LastUpdated = ({ duration }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Text size="small" tone="secondary">
      {t('UPDATED_DATE', {
        lastModifiedDuration: duration,
      })}
    </Text>
  );
};
